export default __webpack_public_path__ + "1c1cfd020661933c4a279067dd1ff0fb.png";